import { cva, type VariantProps } from 'class-variance-authority'
import type { ButtonHTMLAttributes } from 'react'

import { cn } from '../cn.js'

/** Button classes by variant; also used to style links as buttons. */
export const buttonVariants = cva(
  'inline-flex min-h-11 items-center justify-center gap-2 rounded-[14px] px-5 font-semibold transition-colors duration-150 ease-state disabled:cursor-not-allowed disabled:opacity-55',
  {
    variants: {
      variant: {
        primary: 'bg-accent text-on-accent hover:bg-accent-soft',
        secondary: 'border border-line bg-surface text-text hover:border-muted',
        ghost: 'bg-transparent text-text hover:bg-surface',
      },
    },
    defaultVariants: { variant: 'primary' },
  }
)

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants>

/** Buttons are at least 44 px high (touch target); `type` defaults to "button". */
export function Button({ className, variant, type = 'button', ...props }: ButtonProps) {
  return <button type={type} className={cn(buttonVariants({ variant }), className)} {...props} />
}
